import React from 'react';
import { gettext } from '@eventbrite/i18n';

import { withMainControls } from '@eventbrite/eds-structure';
import { Button } from '@eventbrite/eds-button';
import { CompleteSignupContainer } from '@eventbrite/auth-lib';

import './SignupPage.scss';

import { getSignupConfiguration } from './config';
import SplitContainer from '../../connectedComponents/SplitContainer';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SIGN_UP_PATH
 */
const SignupPage = ({
    stld,
    gaSettings,
    captcha,
    socialSSOSettings,
    fp,
    referrer,
    skipSocialCalls,
    socialDataMock,
    routing,
    dispatchUpdateFormType,
    redirectToLogInAction,
    featureFlags,
}) => {
    return (
        <SplitContainer shouldShowSecondaryPanel={true} usesNewStyles={true}>
            <CompleteSignupContainer
                configuration={getSignupConfiguration({
                    request: { stld },
                    gaSettings,
                    captcha,
                    socialSSOSettings,
                    skipSocialCalls,
                    socialDataMock,
                    fp,
                    referrer,
                    dispatchUpdateFormType,
                    redirectToLogInAction,
                    featureFlags,
                })}
                routing={routing}
            />

            <div className="eds-text-color--ui-800 eds-text-weight--heavy eds-l-pad-bot-5 eds-show-up-md">
                <Button
                    type="button"
                    style="anchor"
                    onClick={(event) => {
                        event.preventDefault();

                        redirectToLogInAction?.();
                    }}
                    data-testid="go-to-signup"
                >
                    {gettext('Log in')}
                </Button>
            </div>
        </SplitContainer>
    );
};

export default withMainControls(SignupPage);
